export enum SolutionSpace {
  Utilization = 'utilization',
  Humidity = 'humidity',
}
export const enum NumericUtilOrHumid {
  Utilization,
  Humidity,
}
